import React, {useState} from "react"

import {FieldTableCellProps} from "../../../../../../render/table/table-cell"
import {EntityType} from "../../../../../../../gd/const/item"
import FieldProto_updateView from "../../../../../../proto/render/table/function/update-view"
import FieldToggle_TableCellCalculated_Hovered from "./hovered"
import FieldToggle_TableCellCalculated_NotHovered from "./not-hovered"


// const debug = "FieldToggle_TableCellCalculated"
const debug = false

export default function FieldToggle_TableCellCalculated(props: FieldTableCellProps) {

    const [isHovered, setIsHovered]     = useState(false)
    
    let isEditable: boolean
    switch (props.listItem.type) {
        case EntityType.TASK:
        case EntityType.PROJECT:
            isEditable = !props.manager.isReadOnly && (!props.field.isCustom || props.listItem.availableCustomFieldsIds.includes(props.field.fieldId))
            break

        case EntityType.EVENT:
        case EntityType.GROUP:
        default:
            isEditable = false
    }

    const onMouseEnter = () => {
        if (!isEditable) {
            return
        }
        setIsHovered(true)
    }

    const onMouseLeave = () => {
        setIsHovered(false)
    }

    const onValueChange = (value: boolean) => {
        props.listItem.item.setCustomFieldValue(props.field.fieldId, value)
        props.listItem.item.save()

        // need it because of calculated values
        props.manager.updateChildrenItems()

        FieldProto_updateView(props.manager, props.field)
    }

    const width = props.column.width

    const style : style = _.clone(props.style) || {} // we need clone here because we add width!
    style.width = width

    debug && console.log(debug, "render() isHovered=", isHovered)

    if (isHovered) {
        return (
            <FieldToggle_TableCellCalculated_Hovered
                style           = {style}
                field           = {props.field}
                listItem        = {props.listItem}
                isEditable      = {isEditable}
                onMouseEnter    = {onMouseEnter}
                onMouseLeave    = {onMouseLeave}
                onChange        = {onValueChange}
            />
        )
    } else {
        return (
            <FieldToggle_TableCellCalculated_NotHovered
                style           = {style}
                field           = {props.field}
                listItem        = {props.listItem}
                isEditable      = {isEditable}
                column          = {props.column}
                onMouseEnter    = {onMouseEnter}
                onMouseLeave    = {onMouseLeave}
            />
        )
    }
}
